<template>
  <div class="text-center" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
    <span class="logo-lg">
      <img :src="whiteLabel || require('@/assets/images/logo-small.png')" alt height="50" />
    </span>
    <div></div>
    <div>
      {{ $t("common.redirect") }}
    </div>
    <div>
      {{ redirectUrl }}
    </div>
  </div>
</template>

<script>
const state = "mailLog";

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    redirectUrl() {
      const raw = this.$route.query.redirectUrl;
      if (!raw || typeof raw !== "string") return "/";

      let url;
      try {
        url = new URL(raw, window.location.origin);
      } catch (e) {
        return "/";
      }

      // Only allow same-origin internal paths; disallow external hosts and non-http schemes
      if (url.origin !== window.location.origin) {
        return "/";
      }

      if (url.protocol !== "https:" && url.protocol !== "http:") {
        return "/";
      }

      return `${url.pathname}${url.search}${url.hash}`;
    },
  },
  async mounted() {
    const id = this.$route.query.id;
    try {
      await this.$store.dispatch("mailLog/readMail", id);
    } finally {
      setTimeout(() => {
        const organizationId = this.$route.query.organizationId;
        if (organizationId) {
          return this.selectOrganizationAndGo({ _id: organizationId }, this.redirectUrl);
        }
        window.location.href = this.redirectUrl;
      }, 1000);
    }
  },
};
</script>
